var _g, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGmGlobeChat = function SvgGmGlobeChat(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 24,
    r: 21,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.005 25.6964C31.9277 25.6964 31.8505 25.6964 31.7733 25.6964C28.2717 25.6964 24.7443 25.6964 21.2427 25.6964C21.1397 25.6964 21.0625 25.6964 20.908 25.6964C20.9852 24.8724 21.0625 24.1 21.114 23.2761C22.0409 23.2761 22.9163 23.2761 23.7917 23.2761C23.7917 22.9414 23.7917 22.6324 23.7917 22.2977C22.9678 22.2977 22.1696 22.2977 21.3457 22.2977C21.3457 22.2462 21.3457 22.2205 21.3457 22.169C21.5517 21.2936 21.8349 20.4439 22.2983 19.6715C22.6588 19.1051 23.045 18.5387 23.7917 18.4357C23.7917 18.1267 23.7917 17.8177 23.7917 17.4573C23.3797 17.5088 22.9678 17.5345 22.5815 17.586C20.9595 17.8177 19.5176 18.4357 18.256 19.4913C16.634 20.8816 15.6041 22.6324 15.2694 24.7695C15.2179 25.0012 15.1921 25.2587 15.1406 25.4904C15.1406 25.9538 15.1406 26.3915 15.1406 26.855C15.1921 27.0867 15.2179 27.3442 15.2694 27.5759C15.6041 29.7129 16.634 31.4637 18.2818 32.8541C19.5434 33.9097 20.9852 34.5534 22.6073 34.7593C22.7875 34.7851 22.9678 34.8108 23.148 34.8623C23.6114 34.8623 24.0491 34.8623 24.5126 34.8623C24.6928 34.8366 24.873 34.7851 25.0533 34.7593C26.1346 34.6049 27.1645 34.2444 28.1172 33.7037C29.5075 32.9313 30.5889 31.8499 31.3613 30.4853C32.108 29.1722 32.4942 27.7561 32.4942 26.237C32.5199 25.9023 32.3397 25.7221 32.005 25.6964ZM26.7268 26.6747C26.7011 27.1382 26.6753 27.6274 26.6238 28.0651C26.5723 28.477 26.5209 28.889 26.4436 29.3267C26.4179 29.4554 26.3921 29.5327 26.2376 29.5327C24.6156 29.5327 22.9935 29.5327 21.3714 29.5327C21.3457 29.5327 21.2942 29.5327 21.1912 29.5069C21.0882 28.58 20.9852 27.6274 20.8822 26.649C22.8648 26.6747 24.77 26.6747 26.7268 26.6747ZM21.7834 18.7446C21.011 19.8518 20.6248 21.0619 20.3415 22.2977C19.2859 22.2977 18.2303 22.2977 17.1489 22.2977C18.256 20.5212 19.7494 19.3368 21.7834 18.7446ZM16.3765 24.1515C16.428 23.8941 16.531 23.6623 16.6082 23.4306C16.6597 23.3534 16.7369 23.2761 16.8142 23.2761C17.8956 23.2761 18.9769 23.2761 20.0841 23.2761C20.1098 23.2761 20.1356 23.2761 20.1613 23.3019C20.1098 24.1 20.0326 24.8724 19.9811 25.6706C18.7195 25.6706 17.4579 25.6706 16.119 25.6706C16.1963 25.1557 16.2735 24.6407 16.3765 24.1515ZM16.7884 29.3524C16.428 28.5543 16.222 27.7304 16.1448 26.855C16.1448 26.8035 16.1448 26.752 16.1448 26.7005C17.4321 26.7005 18.6937 26.7005 19.9553 26.7005C20.0326 27.6531 20.1356 28.6058 20.2128 29.5842C20.1613 29.5842 20.0841 29.5842 20.0068 29.5842C19.0542 29.5842 18.0758 29.5842 17.1232 29.5842C16.9429 29.5584 16.8657 29.5069 16.7884 29.3524ZM17.4579 30.5368C17.5609 30.5368 17.6123 30.5368 17.6896 30.5368C18.5392 30.5368 19.4146 30.5368 20.2643 30.5368C20.393 30.5368 20.4703 30.5368 20.496 30.6913C20.7535 31.7212 21.1397 32.6996 21.7834 33.6265C19.9553 33.0858 18.5392 32.0559 17.4579 30.5368ZM24.6928 33.4977C24.1521 34.0384 23.5342 34.0127 22.9678 33.4977C22.4271 32.9828 22.1181 32.3391 21.8349 31.6697C21.6804 31.3092 21.5774 30.923 21.4487 30.5368C23.045 30.5368 24.5898 30.5368 26.1861 30.5368C25.8514 31.6182 25.5167 32.6738 24.6928 33.4977ZM25.8772 33.6265C26.5209 32.6996 26.8813 31.6954 27.1645 30.6913C27.1903 30.6398 27.2675 30.5368 27.3448 30.5368C28.2717 30.5368 29.2243 30.5368 30.2027 30.5368C29.1213 32.0559 27.7052 33.06 25.8772 33.6265ZM31.0009 29.0177C30.7949 29.5584 30.7691 29.5584 30.2027 29.5584C29.353 29.5584 28.5291 29.5584 27.6795 29.5584C27.6022 29.5584 27.525 29.5584 27.4478 29.5584C27.525 28.6058 27.628 27.6531 27.7052 26.7005C28.9411 26.7005 30.2027 26.7005 31.5158 26.7005C31.4643 27.4987 31.3098 28.2711 31.0009 29.0177Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.912 15.526C22.2467 15.526 22.5557 15.526 22.8904 15.526C22.8904 15.1913 22.8904 14.9081 22.8904 14.5734C23.2251 14.5734 23.5341 14.5734 23.8173 14.5734C23.8173 14.2387 23.8173 13.9297 23.8173 13.595C23.5083 13.595 23.1993 13.595 22.8646 13.595C22.8646 13.2603 22.8646 12.9513 22.8646 12.6423C22.5299 12.6423 22.221 12.6423 21.8862 12.6423C21.8862 12.9513 21.8862 13.2603 21.8862 13.595C21.5515 13.595 21.2426 13.595 20.9336 13.595C20.9336 13.9297 20.9336 14.2387 20.9336 14.5734C21.2426 14.5734 21.5515 14.5734 21.8862 14.5734C21.912 14.9338 21.912 15.217 21.912 15.526Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3842 24.4091C36.3842 24.3576 36.3069 24.2546 36.2554 24.2546C35.9722 24.2289 35.7147 24.2546 35.4058 24.2546C35.4058 24.5893 35.4058 24.8983 35.4058 25.233C35.0711 25.233 34.7621 25.233 34.4531 25.233C34.4531 25.5677 34.4531 25.8767 34.4531 26.1856C34.7621 26.1856 35.0711 26.1856 35.4058 26.1856C35.4058 26.5204 35.4058 26.8293 35.4058 27.1383C35.7405 27.1383 36.0494 27.1383 36.3842 27.1383C36.3842 26.8036 36.3842 26.5204 36.3842 26.1856C36.7189 26.1856 37.0278 26.1856 37.3368 26.1856C37.3368 25.8509 37.3368 25.542 37.3368 25.233C37.0278 25.233 36.7189 25.233 36.3842 25.233C36.3842 24.924 36.3842 24.6666 36.3842 24.4091Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7203 11.9729C37.5401 11.8699 37.3341 11.7927 37.1282 11.6897C33.4206 11.6897 29.6872 11.6897 25.9539 11.6897L25.9282 11.7154C25.2072 11.8957 24.7695 12.5136 24.7695 13.3633C24.7953 14.8823 24.7695 16.4014 24.7695 17.9205C24.7695 19.0276 24.7695 20.109 24.7695 21.2161C24.7695 22.1688 25.3617 22.7867 26.3401 22.7867C27.164 22.7867 28.0137 22.7867 28.8376 22.7867C28.9148 22.7867 29.0178 22.7867 29.1208 22.7867C29.1208 23.0699 29.1208 23.3274 29.1208 23.5849C29.1208 23.7394 29.1208 23.9196 29.1208 24.0741C29.1208 24.3315 29.1465 24.5633 29.4298 24.6662C29.6872 24.7692 29.8932 24.6405 30.0734 24.4603C30.3567 24.1771 30.6656 23.8681 30.9488 23.5849C31.1548 23.3789 31.3865 23.1472 31.5925 22.9412C31.6955 22.8125 31.8242 22.7867 31.9787 22.7867C33.5493 22.7867 35.1199 22.7867 36.7162 22.7867C37.2569 22.7867 37.7203 22.6322 38.0293 22.1945C38.158 22.04 38.2095 21.8341 38.3125 21.6538C38.3125 18.7187 38.3125 15.8092 38.3125 12.8741C38.1838 12.5136 38.0293 12.1789 37.7203 11.9729ZM34.9139 18.2037C34.4247 18.2037 34.0127 17.7918 34.0127 17.3026C34.0127 16.8134 34.4247 16.4014 34.9139 16.4014C35.4031 16.4014 35.815 16.8134 35.815 17.3026C35.815 17.7918 35.4031 18.2037 34.9139 18.2037ZM27.4472 17.3026C27.4472 16.8134 27.8592 16.4014 28.3484 16.4014C28.8376 16.4014 29.2495 16.8134 29.2495 17.3026C29.2495 17.7918 28.8376 18.2037 28.3484 18.2037C27.8592 18.2037 27.4472 17.7918 27.4472 17.3026ZM30.7944 17.3026C30.7944 16.8134 31.2063 16.4014 31.6955 16.4014C32.1847 16.4014 32.5967 16.8134 32.5967 17.3026C32.5967 17.7918 32.1847 18.2037 31.6955 18.2037C31.2063 18.2037 30.7944 17.7918 30.7944 17.3026Z",
    fill: "url(#paint3_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 15.1406,
    y1: 17.4573,
    x2: 33.1217,
    y2: 18.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C78D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.192708,
    stopColor: "#CF9428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322917,
    stopColor: "#F3C36A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#F3C46C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#E9B559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958333,
    stopColor: "#CE9326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 20.9336,
    y1: 12.6423,
    x2: 23.9211,
    y2: 12.7542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C78D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.192708,
    stopColor: "#CF9428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322917,
    stopColor: "#F3C36A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#F3C46C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#E9B559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958333,
    stopColor: "#CE9326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 34.4531,
    y1: 24.2432,
    x2: 37.4407,
    y2: 24.3546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C78D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.192708,
    stopColor: "#CF9428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322917,
    stopColor: "#F3C36A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#F3C46C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#E9B559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958333,
    stopColor: "#CE9326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 24.7695,
    y1: 11.6897,
    x2: 38.7985,
    y2: 12.2366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C78D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.192708,
    stopColor: "#CF9428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322917,
    stopColor: "#F3C36A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#F3C46C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#E9B559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958333,
    stopColor: "#CE9326"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGmGlobeChat);
export default ForwardRef;